<template>
  <div class="ProductInfoComponent">
    <div
      class="info-card"
      v-for="(feature, i) in features"
      :key="i"
    >
      <img :src="feature.image" alt="" />

      <p>
        {{ feature.text }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface PropsInterface {
  features: { image: string; text: string }[]
}

withDefaults(defineProps<PropsInterface>(), {
  features: () => []
})
</script>

<style lang="scss" scoped>
.ProductInfoComponent {
  margin: $spacing-2xl 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $gap-xl;

  @include breakpoint-lg {
    margin: $spacing-64 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: $gap-2xl;
    max-width: $size-1200;
  }

  .info-card {
    max-width: 36ch;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: $gap-xl;

    i[class^='icon-'] {
      display: block;
      font-size: 3rem;
      text-align: center;
      color: $color-primary;
    }

    p {
      text-align: center;
      color: $color-neutral-dark;
      font-size: $font-size-m;
    }
  }
}

img {
  width: 50px;
  margin: auto;
}
</style>
